import { render, staticRenderFns } from "./ElementStudioWidthAdjustmentBarAdjustmentHandle.vue?vue&type=template&id=8dd64aaa&"
import script from "./ElementStudioWidthAdjustmentBarAdjustmentHandle.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioWidthAdjustmentBarAdjustmentHandle.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioWidthAdjustmentBarAdjustmentHandle.vue?vue&type=style&index=0&id=8dd64aaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports